import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Export phone utilities
export {
  formatPhoneNumber,
  stripPhoneFormatting,
  isValidArgentinaPhone,
  normalizePhoneNumber,
  getAreaCode,
  getLocalNumber,
} from './utils/phone'

// Export initials utilities
export { getInitials } from './utils/initials'

// Export social media utilities
export {
  parseInstagramUrl,
  parseFacebookUrl,
  parseGoogleMapsUrl,
  sanitizeInstagramInput,
  sanitizeFacebookInput,
} from './utils/socialMedia'
